import React from 'react';
import { ViewColumnsIcon } from '@heroicons/react/24/outline';

const BTN = 'inline-flex items-center gap-1.5 rounded border border-[#E9EDF6] bg-white px-2.5 py-1 text-xs font-medium text-[#637381] hover:bg-slate-50 transition-colors';

/**
 * Unified export / column-toggle toolbar row shown above data tables.
 * Replaces ad-hoc Copy/CSV/Excel/PDF/Print buttons re-implemented per page.
 */
const TableToolbar = ({
  onCopy,
  onCSV,
  onExcel,
  onPDF,
  onPrint,
  onColumnsChange,
  showColumns = true,
  extraButtons,
  className = '',
}) => (
  <div className={`flex flex-wrap items-center gap-1 ${className}`}>
    {showColumns && onColumnsChange && (
      <>
        <button type="button" onClick={onColumnsChange} className={BTN}>
          <ViewColumnsIcon className="h-3.5 w-3.5" />
          Columns
        </button>
        <span className="mx-0.5 h-4 w-px bg-[#E9EDF6]" />
      </>
    )}
    {onCopy   && <button type="button" onClick={onCopy}   className={BTN}>Copy</button>}
    {onCSV    && <button type="button" onClick={onCSV}    className={BTN}>CSV</button>}
    {onExcel  && <button type="button" onClick={onExcel}  className={BTN}>Excel</button>}
    {onPDF    && <button type="button" onClick={onPDF}    className={BTN}>PDF</button>}
    {onPrint  && <button type="button" onClick={onPrint}  className={BTN}>Print</button>}
    {extraButtons}
  </div>
);

export default TableToolbar;
